export const dateFromFechaString = (f: string) => {
  if (!f) {
    console.error("dateFromFechaString: cadena buida o null:", f);
    return new Date(NaN);
  }

  const dateTimeParts = f.split(" ");
  if (dateTimeParts.length !== 2) {
    console.error("dateFromFechaString: format incorrecte (falten espais):", f);
    return new Date(NaN);
  }

  const dateParts = dateTimeParts[0].split("/");
  const timeParts = dateTimeParts[1].split(":");

  if (dateParts.length !== 3 || timeParts.length < 2) {
    console.error("dateFromFechaString: format incorrecte (data o hora mal formada):", f);
    return new Date(NaN);
  }

  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const year = parseInt(dateParts[2], 10);
  const hours = parseInt(timeParts[0], 10);
  const minutes = parseInt(timeParts[1], 10);

  const date = new Date(year, month, day, hours, minutes);
  if (isNaN(date.getTime())) {
    console.error("dateFromFechaString: resultat és NaN:", f, "->", date);
  }

  return date;
};


export const getUploadPath = (
  qrType: "vetlla" | "sala",
  id: number,
  obert: boolean = false,
) => {
  let path = `/upload/${qrType}/${id}`;
  if (obert) {
    path += "?c=0";
  }

  return path;
};
